module.exports = __webpack_public_path__ + "img/css.a8db47b7.svg";